import React, { useState, useEffect } from 'react';
import { CheckCircle2, Circle, Loader2, Wrench, ArrowDownRight } from 'lucide-react';
import { useLang } from '../i18n';
import { Card, Button, Spinner } from './ui';
import api, { vnd } from '../api';

export default function SettlementTracker({ claimId }) {
  const { t, lang } = useLang();
  const [track, setTrack] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => api.get(`/claims/${claimId}/settlement`).then((r) => setTrack(r.data)).catch(() => {});
  useEffect(() => { if (claimId) load(); /* eslint-disable-next-line */ }, [claimId]);

  const advance = async () => {
    setLoading(true);
    try { const r = await api.post(`/claims/${claimId}/settlement/advance`); setTrack(r.data); }
    finally { setLoading(false); }
  };

  if (!track || !track.stages?.length) return null;
  const done = track.current_index >= track.stages.length;

  return (
    <Card className="p-5" data-testid="settlement-tracker">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2"><Wrench className="w-4 h-4 text-jade" /><span className="kicker">{t('settlement_tracker')}</span></div>
        <span className="font-mono text-jade text-sm">{vnd(track.amount_vnd)}</span>
      </div>

      <div className="relative pl-2">
        {track.stages.map((s, i) => {
          const isDone = s.status === 'done';
          const isCurrent = s.status === 'current';
          return (
            <div key={s.key} className="flex gap-3 pb-4 last:pb-0 relative" data-testid={`stage-${s.key}`}>
              {i < track.stages.length - 1 && (
                <div className={`absolute left-[11px] top-6 bottom-0 w-px ${isDone ? 'bg-jade/50' : 'bg-white/10'}`} />
              )}
              <div className="shrink-0 z-10">
                {isDone ? <CheckCircle2 className="w-6 h-6 text-jade" />
                  : isCurrent ? <Loader2 className="w-6 h-6 text-amber animate-spin" />
                  : <Circle className="w-6 h-6 text-slate-600" />}
              </div>
              <div className="pt-0.5">
                <div className={`text-sm ${isDone ? 'text-slate-300' : isCurrent ? 'text-amber font-semibold' : 'text-slate-500'}`}>
                  {lang === 'vi' ? s.label_vi : s.label_en}
                </div>
                {s.at && <div className="text-[10px] font-mono text-slate-600">{s.at.slice(0, 19).replace('T', ' ')}</div>}
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-xs text-slate-500 mb-3">{track.garage}</div>
      {!done && (
        <Button variant="ghost" data-testid="advance-settlement" onClick={advance} disabled={loading} className="w-full">
          {loading ? <Spinner label="…" /> : <><ArrowDownRight className="w-4 h-4" /> {t('advance_stage')}</>}
        </Button>
      )}
    </Card>
  );
}
